import React, { useState, useEffect } from 'react';
import Axios from '../../Components/Axios/Axios';
import Auth from '../../Components/Auth/Auth';
import { useHistory } from 'react-router-dom';
import { USER_KEY } from '../../Constants/index';
import { Button, Grid, Paper, InputAdornment, TextField, Autocomplete, MenuItem } from '@mui/material';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import FadeLoader from "react-spinners/FadeLoader";
import icon_success from '../../Images/Icons/success.png';
import icon_failed from '../../Images/Icons/error.png';
import dateFormat from 'dateformat';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

function QueueCreate({ refresh }) {
    // For History
    const history = useHistory();

    // Set Loading
    const [loading, setLoading] = useState(false);

    // For Set Style Paper
    const paperStyle = { padding: 20, width: 'auto' }

    // For Get Current Date
    let _today = new Date();
    let _day = _today.getDate().toString();
    let _month = (_today.getMonth() + 1).toString();
    let _year = _today.getFullYear().toString();
    let _conDay = (_day.length == 2) ? _day : '0' + _day;
    let _conMonth = (_month.length == 2) ? _month : '0' + _month;
    let _showDate = _conDay + "/" + _conMonth + "/" + _year;

    //  For Day of Week Numbers
    let _charDay = _today.getDay();
    if (_charDay == 1) {
        _charDay = "ວັນຈັນ";
    } else if (_charDay == 2) {
        _charDay = "ວັນອັງຄານ";
    } else if (_charDay == 3) {
        _charDay = "ວັນພຸດ";
    } else if (_charDay == 4) {
        _charDay = "ວັນພະຫັດ";
    } else if (_charDay == 5) {
        _charDay = "ວັນສຸກ";
    } else if (_charDay == 6) {
        _charDay = "ວັນເສົາ";
    } else {
        _charDay = "ວັນອາທິດ";
    }

    // For get All Queue in Site Today
    const [dataAllQueue, setDataAllQueue] = useState([]);

    // For get Employee Check-in Data
    const [dataCheckIn, setDataCheckIn] = useState([]);
    const [dataTarget, setDataTarget] = useState([]);
    const [dataProv, setDataProv] = useState("");
    const [dataSite, setDataSite] = useState("");
    const [dataCounter, setDataCounter] = useState("");
    const [dataCounterID, setDataCounterID] = useState("");

    // Get data to Create Queue Walk-in
    const [cusName, setCusName] = useState("");
    const [cusTel, setCusTel] = useState("");
    const [cusTarget, setTarget] = useState("");
    const [queueNum, setQueueNum] = useState("");

    // For Call Queue Data
    const [valQueueID, setValQueueID] = useState("");
    const [valCusName, setValCusName] = useState("");
    const [valCusTel, setValCusTel] = useState("");
    const [valCusTarget, setValCusTargetƒ] = useState("");
    const [valQueueNum, setValQueueNum] = useState("");

    // For get data from user login
    const tokenData = JSON.parse(localStorage.getItem(USER_KEY));
    const token = tokenData.token;
    const _empID = tokenData.emp_info[0].emp_id;
    const _empCode = tokenData.emp_info[0].emp_code;

    // for Loading Data
    const loadData = async () => {
        setLoading(true)

        let _siteID = "";

        // For get Data Check-in
        try {
            await Axios.post("Emp/Check_in/Date", { "employee_id": _empID }, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                // Check token Expired
                if (res.data.result_code == '403') {
                    Auth.logout(() => {
                        history.push("/");
                    });
                }

                if (res.data.result_code == "200") {
                    setDataCheckIn(res.data.emp_check_in_list)
                    let cycle = res.data.emp_check_in_list.length;
                    setDataProv(res.data.emp_check_in_list[cycle - 1].prov_name)
                    setDataSite(res.data.emp_check_in_list[cycle - 1].site_name)
                    setDataCounter(res.data.emp_check_in_list[cycle - 1].counter_name)
                    setDataCounterID(res.data.emp_check_in_list[cycle - 1].counter_id)
                    _siteID = res.data.emp_check_in_list[cycle - 1].site_id;
                }
            })
        } catch (error) {
            // console.log(error)
        }

        // All Customer Target Data
        try {
            await Axios.get("Customer/Target/All/Active", { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                // Check token Expired
                if (res.data.result_code == '403') {
                    Auth.logout(() => {
                        history.push("/");
                    });
                }

                if (res.data.result_code == "200") {
                    setDataTarget(res.data.customer_target_list)

                }
            })
        } catch (error) {
            // console.log(error)
        }

        // All Queue in Site Today
        try {
            // Check Site ID
            let siteData = { "site_id": _siteID, "emp_code": _empCode }

            await Axios.post("Reservation/Queue/All/Create", siteData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                // Check token Expired
                if (res.data.result_code == '403') {
                    Auth.logout(() => {
                        history.push("/");
                    });
                }

                if (res.data.result_code == "200") {
                    setDataAllQueue(res.data.queue_list)
                }
            })

        } catch (error) {
            // console.log(error)
        }

        setTimeout(() => {
            setLoading(false)
        }, 500);
    }

    useEffect(() => {
        loadData()
    }, [refresh])

    // For Dialog Create Queue Walk-in
    const [queueWalkIn, setQueueWalkIn] = useState(false);

    // For Dialog Call Queue
    const [callQueue, setCallQueue] = useState(false);
    const [confirmCancel, setConfirmCancel] = useState(false);

    // For Any Alert Success/Failed
    const [openQueueSuccess, setOpenQueueSuccess] = useState(false);
    const [openQueueFailed, setOpenQueueFailed] = useState(false);
    const [openCancelSuccess, setOpenCancelSuccess] = useState(false);
    const [openCancelFailed, setOpenCancelFailed] = useState(false);
    const [openConfirmSuccess, setOpenConfirmSuccess] = useState(false);
    const [openConfirmFailed, setOpenConfirmFailed] = useState(false);

    // Function for Tab Queue Waiting    
    const tabWaiting = () => {
        history.push({
            pathname: '/home/queue/list',
        })
    }

    // Function for Tab Queue Success    
    const tabSuccess = () => {
        history.push({
            pathname: '/home/queue/pass',
        })
    }

    // Function for Create Queue Walk-in
    const addQueueWalkIn = async () => {
        if (cusName != "" && cusTel != "" && cusTarget != "") {
            // Check Site ID
            let cycle = dataCheckIn.length;
            let _siteID = dataCheckIn[cycle - 1].site_id;

            let queueData = {
                "site_id": _siteID,
                "customer_name": cusName,
                "customer_tel": cusTel,
                "customer_target": cusTarget,
                "create_by": _empCode
            }

            try {
                await Axios.post("Reservation/New/Walk/In/Queue", queueData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "200") {
                        setQueueNum(res.data.queue_number)
                        setQueueWalkIn(false);
                        setOpenQueueSuccess(true);
                    } else {
                        setOpenQueueFailed(true);
                    }
                })
            } catch (error) {
                // console.log(error)
            }
        }
    }

    // Function for Cancel Queue
    const cancelQueue = async () => {
        if (valQueueID != "") {
            let cancelData = {
                "queue_id": valQueueID,
                "update_by": _empCode
            }

            try {
                await Axios.post("Update/Queue/Status/Expired", cancelData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "200") {
                        setConfirmCancel(false);
                        setCallQueue(false);
                        setOpenCancelSuccess(true);
                    } else {
                        setConfirmCancel(false);
                        setCallQueue(false);
                        setOpenCancelFailed(true);
                    }
                })
            } catch (error) {
                // console.log(error)
            }
        }
    }

    // Function for Confirm Bill Service
    const confirmService = async () => {
        if (dataCounterID != "" && valQueueID != "") {
            let confirmData = {
                "queue_id": valQueueID,
                "counter_id": dataCounterID,
                "update_by": _empCode
            }

            try {
                await Axios.post("Update/Queue/Status/Progress", confirmData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "200") {
                        setCallQueue(false);
                        setOpenConfirmSuccess(true);
                    } else {
                        setOpenConfirmFailed(true);
                    }
                })
            } catch (error) {
                // console.log(error)
            }
        }
    }

    return (
        <>
            {loading ? <>
                <div className='manage_loading'>
                    <FadeLoader color={'#ED1C24'} loading={loading} size={10} />
                </div>
            </> : <>
                {dataCheckIn && dataCheckIn.length > 0 ? <>
                    {dataCheckIn[dataCheckIn.length - 1].status_name == 'available' || dataCheckIn[dataCheckIn.length - 1].status_name == 'progress' ? <>
                        <div className='manage_title'>ຄິວລູກຄ້າ <span className='manage_title_date'>{_charDay}, {_showDate}</span></div>

                        <Paper elevation={10} style={paperStyle} className='manage_paper'>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Grid item xs={10} style={{ marginBottom: 10 }}>
                                        <span className='manage_input_label'>ແຂວງ:</span>
                                    </Grid>

                                    <Grid item xs={10}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            value={dataProv}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>

                                <Grid item xs={3}>
                                    <Grid item xs={10} style={{ marginBottom: 10 }}>
                                        <span className='manage_input_label'>ສູນບໍລິການ:</span>
                                    </Grid>

                                    <Grid item xs={10}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            value={dataSite}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>

                                <Grid item xs={3}>
                                    <Grid item xs={10} style={{ marginBottom: 10 }}>
                                        <span className='manage_input_label'>ປ່ອງບໍລິການ:</span>
                                    </Grid>

                                    <Grid item xs={10}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            value={dataCounter}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>

                                <Grid item xs={3}>
                                    <Grid container>
                                        <Grid xs={4}></Grid>
                                        <Grid xs={8} style={{ marginTop: 33 }}>
                                            <Button className="manage_breake_button" fullWidth variant="outlined" onClick={() => { setQueueWalkIn(true) }}>ສ້າງຄິວ Walk-in</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>

                        <Grid container>
                            <Grid item xs={6}>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Button variant='contained' className='manage_tab_select'><span>ຄິວຕົນເອງສ້າງ</span></Button>
                                    </Grid>

                                    <Grid item xs={4}>
                                        <Button variant='contained' className='manage_tab_no_select' onClick={tabWaiting}><span>ຄິວກໍາລັງລໍຖ້າ</span></Button>
                                    </Grid>

                                    <Grid item xs={4}>
                                        <Button variant='contained' className='manage_tab_no_select' onClick={tabSuccess}><span>ຄິວທີ່ຜ່ານມາ</span></Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Paper elevation={10} style={paperStyle} className='manage_paper'>
                            <div className='manage_title'>ຂໍ້ມູນຄິວທີ່ກໍາລັງລໍຖ້າ</div>
                            <Grid item xs={12} style={{ marginTop: 20 }}>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ເລກຄິວ</span></TableCell>
                                                <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ເວລາຈອງ</span></TableCell>
                                                <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ປະເພດຄິວ</span></TableCell>
                                                <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ຊື່ລູກຄ້າ</span></TableCell>
                                                <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ເບີໂທລະສັບ</span></TableCell>
                                                <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ເປົ້າໝາຍ</span></TableCell>
                                                <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ປ່ອງບໍລິການ</span></TableCell>
                                                <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ສະຖານະຄິວ</span></TableCell>
                                                <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ເອີ້ນຄິວ</span></TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {dataAllQueue && dataAllQueue.length > 0 ?
                                                <>
                                                    {dataAllQueue.map((row, idx) => (
                                                        <TableRow key={idx}>
                                                            <TableCell align='center'><span className='manage_table_data'>{row.queue_number}</span></TableCell>
                                                            <TableCell align='left'><span className='manage_table_data'> {dateFormat(row.queue_date, "dd/mm/yyyy HH:MM:ss")}</span></TableCell>
                                                            <TableCell align='center'><span className='manage_table_data'>{row.queue_type}</span></TableCell>
                                                            <TableCell align='left'><span className='manage_table_data'>{row.cus_name}</span></TableCell>
                                                            <TableCell align='left'><span className='manage_table_data'>{row.cus_tel}</span></TableCell>
                                                            <TableCell align='left'><span className='manage_table_data'>{row.target}</span></TableCell>
                                                            <TableCell align='left'><span className='manage_table_data'>{row.counter_name}</span></TableCell>
                                                            <TableCell align='center'>
                                                                <span className='manage_table_data'>
                                                                    {row.queue_status == 'waiting' ? <>
                                                                        <button className='res_status_waiting'>{"waiting"}</button>
                                                                    </> : row.queue_status == 'progress' ? <>
                                                                        <button className='res_status_progress'>{"progress"}</button>
                                                                    </> : row.queue_status == 'success' ? <>
                                                                        <button className='res_status_success'>{"success"}</button>
                                                                    </> : row.queue_status == 'expired' ? <>
                                                                        <button className='res_status_expired'>{"expired"}</button>
                                                                    </> : <></>
                                                                    }
                                                                </span>
                                                            </TableCell>
                                                            <TableCell align='center'>
                                                                <span className='manage_table_data'>
                                                                    {dataCheckIn && dataCheckIn.length > 0 ? <>
                                                                        {dataCheckIn[dataCheckIn.length - 1].status_name == 'available' ? <>
                                                                            {row.queue_status == 'waiting' ? <>
                                                                                <Button className='manage_table_BtnDel' variant='contained' size='small' onClick={() => {
                                                                                    setCallQueue(true);
                                                                                    setValQueueID(row.queue_id);
                                                                                    setValCusName(row.cus_name);
                                                                                    setValCusTel(row.cus_tel);
                                                                                    setValCusTargetƒ(row.target);
                                                                                    setValQueueNum(row.queue_number);
                                                                                }}>
                                                                                    <NotificationsActiveIcon />
                                                                                </Button>
                                                                            </> : <></>}
                                                                        </> : <></>}
                                                                    </> : <></>}
                                                                </span>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </> : <>
                                                    <TableBody>
                                                        <TableCell style={{ justifyContent: "center", alignItems: 'center' }}>No Data...</TableCell>
                                                    </TableBody>
                                                </>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Paper>
                    </> : <>
                        <div className='manage_title'>ກະລຸນາ Check-in ຫຼື Cancel Breake ກ່ອນ...</div>
                    </>}
                </> : <>
                    <div className='manage_title'>ກະລຸນາ Check-in ກ່ອນ...</div>
                </>}

                {/* Dialog Create Queue Walk-in */}
                < Dialog
                    fullWidth={true}
                    open={queueWalkIn}
                    maxWidth={"sm"}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialog_title'>
                            ສ້າງຄິວ Walk-in ໃຫມ່
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ marginBottom: 20 }}>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ຊື່ລູກຄ້າ:</InputAdornment>
                                            }}
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            onChange={(e) => { setCusName(e.target.value) }}
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ເບີໂທລະສັບ:</InputAdornment>
                                            }}
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            onChange={(e) => { setCusTel(e.target.value) }}
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id="input-with-icon-textfield"
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">ເປົ້າໝາຍບໍລິການ:</InputAdornment>
                                        }}
                                        size='small'
                                        variant='outlined'
                                        select
                                        fullWidth
                                        onChange={(e) => { setTarget(e.target.value) }}
                                    >
                                        {dataTarget.map((option) => (
                                            <MenuItem key={option.target_id} value={option.target_name}>
                                                {option.target_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_saveBtn' onClick={addQueueWalkIn}>
                                        ບັນທຶກ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_cancelBtn' onClick={() => { setQueueWalkIn(false); setCusName(""); setCusTel(""); setTarget("") }}>
                                        ຍົກເລີກ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Queue Walk-in Success */}
                <Dialog
                    fullWidth={true}
                    open={openQueueSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_success} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ທ່ານສ້າງຄິວ ສໍາເລັດແລ້ວ ! <br /> ລະຫັດຄິວຂອງທ່ານແມ່ນ {queueNum}
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_successBtn' onClick={() => { setOpenQueueSuccess(false); history.go(0) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Queue Walk-in Failed */}
                <Dialog
                    fullWidth={true}
                    open={openQueueFailed}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ບໍ່ສາມາດຈອງຄິວໄດ້ ລອງໃຫມ່ອີກຄັ້ງ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenQueueFailed(false) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Call Queue */}
                <Dialog
                    fullWidth={true}
                    open={callQueue}
                    maxWidth={"md"}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialog_title'>
                            <Grid container>
                                <Grid item xs={9}>ຢືນຢັນຄິວລູກຄ້າ</Grid>
                                <Grid item xs={3}>
                                    <Button variant='outlined' className='manage_dialog_cancelQueue' color="error" onClick={() => { setConfirmCancel(true) }}>
                                        ຍົກເລີກຄິວ
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ marginBottom: 20 }}>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ເລກທີຄິວ:</InputAdornment>
                                            }}
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            value={valQueueNum}
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ຊື່ລູກຄ້າ:</InputAdornment>
                                            }}
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            value={valCusName}
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ເບີໂທລະສັບ:</InputAdornment>
                                            }}
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            value={valCusTel}
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ເປົ້າໝາຍ:</InputAdornment>
                                            }}
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            value={valCusTarget}
                                        />
                                    </Grid>
                                </Grid>
                            </div>


                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_saveBtn' onClick={confirmService}>
                                        ເລີ່ມບໍລິການ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_cancelBtn' onClick={() => { setCallQueue(false) }}>
                                        ກັບຄືນ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Confirm Cancel Queue */}
                <Dialog
                    fullWidth={true}
                    open={confirmCancel}
                    maxWidth={"sm"}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialog_title'>
                            ຢືນຢັນການຍົກເລີກຄິວ
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ marginBottom: 20 }}>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialog_content'>
                                ທ່ານຕ້ອງການຍົກເລິກຄິວນີ້ແທ້ ຫຼື ບໍ່ ?
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_saveBtn' onClick={cancelQueue}>
                                        ຕົກລົງ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_cancelBtn' onClick={() => { setConfirmCancel(false) }}>
                                        ກັບຄືນ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Cancel Success */}
                <Dialog
                    fullWidth={true}
                    open={openCancelSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_success} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ຍົກເລີກຄິວສໍາເລັດແລ້ວ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_successBtn' onClick={() => { setOpenCancelSuccess(false); history.go(0) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Cancel Failed */}
                <Dialog
                    fullWidth={true}
                    open={openCancelFailed}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ບໍ່ສາມາດຍົກເລີກຄິວດັ່ງກ່າວໄດ້ ລອງໃຫມ່ອີກຄັ້ງ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenCancelFailed(false); history.go(0) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Confirm Success */}
                <Dialog
                    fullWidth={true}
                    open={openConfirmSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_success} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ຮັບຄິວສໍາເລັດ ! <br />
                                ຍ້າຍໄປທີ່ໜ້າເມນູໃຫ້ບໍລິການ
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_successBtn' onClick={() => {
                                        setCallQueue(false);
                                        setOpenConfirmSuccess(false);
                                        history.push("/home/service");
                                    }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Confirm Failed */}
                <Dialog
                    fullWidth={true}
                    open={openConfirmFailed}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ຂໍອະໄພ ຄິວນີ້ມີພະນັກງານທ່ານອື່ນຮັບໄປແລ້ວ ເລືອກຄິວໃຫມ່ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenConfirmFailed(false); history.go(0) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >
            </>}
        </>
    )
}

export default QueueCreate